// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Logo_wrap__18H22"};